export default __webpack_public_path__ + "static/equipo-tom-Color-Grande-0f871ebe20bcbc69e1851be07f37a45a.png";